import React from 'react';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Container from 'components/Container';

const SimpleStriped = () => {
  const theme = useTheme();
  return (
    
    
    <Container>
      
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: 'alternate.dark' }}>
            <TableRow>
              {/* <TableCell>
                <Typography
                  variant={'h6'}
                  fontWeight={700}
                  align='center'
                  sx={{ textTransform: 'uppercase' }}
                >
                Admission sought for
                </Typography>
              </TableCell> */}
              {/* <TableCell>
                <Typography
                  variant={'h6'}
                  fontWeight={700}
                  align='center'
                  
                  sx={{ textTransform: 'uppercase' }}
                >
                Subjects for Entrance Test
                </Typography>
              </TableCell> */}
              <TableCell>
                {/* <Typography
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Title
                </Typography> */}
              </TableCell>   
              <TableCell>
                {/* <Typography
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Status
                </Typography> */}
              </TableCell> 
              <TableCell>
                {/* <Typography
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Role
                </Typography> */}
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default SimpleStriped;